import { create } from 'zustand';

export const useAuthStore = create((set, get) => {
  // Initialize from localStorage on store creation
  const initialToken = typeof window !== 'undefined' ? !!localStorage.getItem('token') : false;
  
  return {
    // Auth state
    hasToken: initialToken,
    setHasToken: (value) => set({ hasToken: value }),
    
    // Initialize from localStorage
    initializeAuth: () => {
      const token = localStorage.getItem('token');
      set({ hasToken: !!token });
    },
    
    // Logout
    logout: (options = {}) => {
      const { reload = true } = options;
      localStorage.clear();
      set({ hasToken: false });
      // Dispatch custom event to notify components
      window.dispatchEvent(new Event('localStorageChange'));
      if (reload) {
        window.location.reload();
      }
    },
  };
});

